import Vue from "vue";
import VueRouter from "vue-router";
import { ROLE } from "@/data/role";
import views from "@/views";
import store from "@/stores";
import * as jwtUtil from "@/utils/jwtUtil";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      // TODO: 개발 단계에만 유지
      path: "/sample",
      component: views.sample_Sample,
    },
    {
      // TODO: 개발 단계에만 유지
      path: "/sample_editor",
      component: views.sample_EditorSample,
    },
    {
      // TODO: 개발 단계에만 유지
      path: "/sample_noticeDetail",
      component: views.sample_NoticeDetailSample,
    },
    {
      // TODO: 개발 단계에만 유지
      path: "/KakaoLogin",
      component: views.sample_KakaoLogin,
    },
    {
      // TODO: 개발 단계에만 유지
      path: "/KakaoLoginPage",
      component: views.sample_KakaoLoginPage,
    },
    {
      path: "/auth",
      component: views.auth_Auth,
      children: [
        {
          path: "",
          component: views.auth_Login,
        },
        {
          path: "join",
          component: views.auth_Join,
        },
        {
          path: "mobileAuth",
          component: views.auth_MobileAuth,
        },
        {
          path: "pwReset",
          name: "PWReset",
          component: views.auth_PWReset,
        },
        {
          path: "pwResetAuth",
          component: views.auth_PWResetAuth,
        },
        {
          path: "privacyForm",
          component: views.auth_PrivacyForm,
        },
        {
          path: "noEmail",
          component: views.auth_NoEmail,
        },
        {
          path: "iDForgot",
          component: views.auth_IDForgot,
        },
        {
          path: "iDForgotComplete",
          name: "IDForgetComplete",
          component: views.auth_IDForgotComplete,
        },
      ],
    },
    {
      // FOR COMMON
      path: "/",
      component: views.common_Common,
      children: [
        {
          // path를 삭제 하면 부모가 component 호출
          path: "",
          component: views.common_Home,
        },
        {
          path: "globalTrend",
          component: views.common_GlobalTrend,
        },
        {
          path: "corpNetworking",
          component: views.common_corpNetworking,
        },
        {
          path: "notice",
          component: views.common_Notice,
        },
        {
          path: "/noticeDetail/:idx",
          name: "noticeDetail",
          component: views.common_NoticeDetail,
        },

        {
          path: "faq",
          component: views.common_FAQ,
        },
        {
          path: "olderConsumers",
          component: views.common_OlderConsumers,
        },
        {
          path: "newagingcenter",
          beforeEnter() {
            window.open("https://newagingplatform.com/about/service", "_blank");
          },
        },
        {
          path: "QnA",
          component: views.common_QNA,
        },
        {
          path: "QnAWrite",
          component: views.common_QNAWrite,
          meta: {
            requiresAuth: true,
            roles: [ROLE.USER, ROLE.CORP, ROLE.ADMIN],
          },
        },
        {
          path: "qNADetail/:idx",
          name: "qNADetail",
          component: views.common_QNADetail,
          meta: {
            requiresAuth: true,
            roles: [ROLE.USER, ROLE.CORP, ROLE.ADMIN],
          },
        },
        {
          path: "survey",
          component: views.common_Survey,
          meta: {
            requiresAuth: false,
            roles: [ROLE.USER, ROLE.CORP],
          },
        },
        {
          path: "survey-result",
          component: views.common_SurveyResult,
        },
        {
          path: "serviceSearch",
          component: views.common_ServiceSearch,
        },
        {
          path: "serviceDetail/:categoryIdx/:idx",
          name: "serviceDetail",
          component: views.common_ServiceDetail,
        },
        {
          path: "newAgingPlatform",
          component: views.common_NewAgingFlatform,
        },
        {
          path: "atWork",
          component: views.common_AtWork,
        },
        {
          path: "productDetail/:categoryIdx/:idx",
          name: "productDetail",
          component: views.common_ProductDetail,
        },
        {
          path: "serviceSearchResult",
          component: views.common_ServiceSearchResult,
        },
        {
          path: "reply",
          component: views.common_Reply,
        },
        {
          path: "reply2",
          component: views.common_Reply2,
        },
        {
          path: "reply3",
          component: views.common_Reply3,
        },
        {
          path: "ServiceSearchNew",
          component: views.common_ServiceSearchNew,
        },
        {
          path: "equipmentData",
          //component: views.common_IncomingFeature,
          component: views.common_EquipmentData,
        },
        {
          path: "centerInfo",
          component: views.common_CenterInfo,
        },
        {
          path: "centerIntro",
          component: views.common_CenterIntro,
        },
        {
          path: "ageTechService",
          name: "ageTechService",
          component: views.user_AgeTechService,
        },
        {
          path: "ageTechServiceDetail/:idx",
          name: "ageTechServiceDetail",
          component: views.user_AgeTechServiceDetail,
        },
      ],
    },
    {
      // FOR ROLE_USER
      path: "/user",
      component: views.user_User,
      meta: {
        requiresAuth: true,
        roles: [ROLE.USER],
      },
      children: [
        {
          path: "",
          component: views.user_UserProfile,
        },
        {
          path: "networking",
          component: views.user_UserProfile,
        },
        {
          path: "searchHistory",
          component: views.user_SearchHistory,
        },
        {
          path: "searchMemberCorp",
          component: views.user_SearchMemberCorp,
        },
        {
          path: "my-page/searchCorporateMembers",
          component: views.user_mypage_SearchCorporateMembers,
        },
        {
          path: "my-page/searchIndividualMember",
          component: views.user_mypage_SearchIndividualMember,
        },
        {
          path: "searchNetworking",
          component: views.user_SearchNetWorking,
        },
        {
          path: "myMatching",
          component: views.user_MyMatching,
        },
      ],
    },
    {
      // FOR ROLE_CORP
      path: "/corp",
      component: views.corp_Corp,
      meta: {
        requiresAuth: true,
        roles: [ROLE.CORP],
      },
      children: [
        {
          path: "",
          component: views.corp_CorpProfile,
        },
        {
          path: "profile",
          component: views.corp_CorpProfile,
        },
        {
          path: "corpProductManagement",
          component: views.corp_CorpProductManagement,
        },
        {
          path: "productEnroll",
          component: views.corp_ProductEnroll,
        },
        {
          path: "productEnroll/:idx",
          component: views.corp_ProductEnroll,
        },
        {
          path: "corpServiceManagement",
          component: views.corp_CorpServiceManagement,
        },
        {
          path: "serviceEnroll",
          component: views.corp_ServiceEnroll,
        },
        {
          path: "serviceEnroll/:idx",
          component: views.corp_ServiceEnroll,
        },
        {
          path: "ProductReject",
          component: views.corp_ProductReject,
        },
        {
          path: "my-page/searchCorporateMembers",
          component: views.corp_mypage_CorpSearchCorporateMembers,
        },
        {
          path: "my-page/searchIndividualMember",
          component: views.corp_mypage_CorpSearchIndividualMember,
        },
        {
          path: "SearchNetworking",
          component: views.corp_SearchNetworking,
        },
        {
          path: "myMatching",
          component: views.corp_MyMatching,
        },
        {
          path: "SurveyResultManagement",
          component: views.corp_SurveyResultManagement,
        },
      ],
    },
    {
      // FOR ROLE_ADMIN
      path: "/admin",
      component: views.admin_Admin,
      meta: {
        requiresAuth: false,
        roles: [ROLE.ADMIN],
      },
      children: [
        {
          path: "",
          component: views.admin_Home,
        },
        {
          path: "accountManagement",
          component: views.admin_AccountManagement,
        },
        {
          path: "accountManagementWrite",
          component: views.admin_AccountManagementWrite,
        },
        {
          path: "accountManagementUserProfile/:idx",
          name: "accountManagementUserProfile",
          component: views.admin_AccountManagementUserProfile,
        },
        {
          path: "accountManagementCorpProfile/:idx",
          name: "accountManagementCorpProfile",
          component: views.admin_AccountManagementCorpProfile,
        },
        {
          path: "surveyManagement",
          component: views.admin_SurveyManagement,
        },
        {
          path: "dataManagement",
          component: views.admin_DataManagement,
        },
        {
          path: "SurveyResultManagement",
          component: views.admin_SurveyResultManagement,
        },
        {
          path: "dataHistoryManagement",
          component: views.admin_DataHistoryManagement,
        },
        {
          path: "noticeManagement",
          component: views.admin_NoticeManagement,
        },
        {
          path: "noticeManagementDetail",
          component: views.admin_NoticeManagementDetail,
        },
        {
          path: "noticeManagementWrite",
          name: "noticeManagementWrite",
          component: views.admin_NoticeManagementWrite,
        },
        {
          path: "noticeManagementWrite/:idx",
          component: views.admin_NoticeManagementWrite,
        },
        {
          path: "noticeManagementModify",
          component: views.admin_NoticeManagementModify,
        },
        {
          path: "fAQManagement",
          component: views.admin_FAQManagement,
        },
        {
          path: "fAQManagementDetail/:idx",
          name: "fAQManagementDetail",
          component: views.admin_FAQManagementDetail,
        },
        {
          path: "fAQManagementWrite",
          name: "fAQManagementWrite",
          component: views.admin_FAQManagementWrite,
        },
        {
          path: "fAQManagementModify",
          component: views.admin_FAQManagementModify,
        },
        {
          path: "qNAManagement",
          component: views.admin_QNAManagement,
        },
        {
          path: "qNAManagementDetail",
          component: views.admin_QNAManagementDetail,
        },
        {
          path: "qNAManagementModify",
          component: views.admin_QNAManagementModify,
        },
        {
          path: "categoryManagement",
          component: views.admin_CategoryManagement,
        },
        {
          path: "productManagement",
          component: views.admin_ProductManagement,
        },
        {
          path: "productManagementDetail",
          component: views.admin_ProductManagementDetail,
        },
        {
          path: "serviceManagement",
          component: views.admin_ServiceManagement,
        },
        {
          path: "serviceManagementDetail",
          component: views.admin_ServiceManagementDetail,
        },
        {
          path: "productDetail/:idx",
          component: views.common_ProductDetail,
        },
        {
          path: "serviceDetail/:idx",
          component: views.common_ServiceDetail,
        },
        {
          path: "napManagement",
          component: views.admin_NapManagement,
        },
        {
          path: "networkManagement",
          component: views.manager_DirectorMatchingManagement,
        },
        {
          path: "napAdvisoryManagement",
          component: views.manager_NAPAdvisoryManagement,
        },
        {
          path: "networkSearch",
          component: views.manager_NetworkSearchPage,
        },
        {
          path: "individualMemberSearch",
          component: views.manager_IndividualMemberSearchPage,
        },
        {
          path: "ageTechService",
          name: "ageTechService",
          component: views.admin_AgeTechService,
        },
        {
          path: "ageTechServiceDetail/:idx",
          name: "ageTechServiceDetail",
          component: views.admin_AgeTechServiceDetail,
        },
        {
          path: "ageTechServiceWrite",
          component: views.admin_AgeTechServiceWrite,
        },
        {
          path: "ageTechServiceModify/:idx",
          component: views.admin_AgeTechServiceModify,
        },
      ],
    },

    {
      // FOR ROLE_MANAGER
      path: "/manager",
      component: views.manager_Manager,
      meta: {
        roles: [ROLE.MANAGER],
      },
      children: [
        {
          path: "networkManagement",
          component: views.manager_DirectorMatchingManagement,
        },
        {
          path: "nAPAdvisoryManagement",
          component: views.manager_NAPAdvisoryManagement,
        },
        {
          path: "networkSearch",
          component: views.manager_NetworkSearchPage,
        },
        {
          path: "individualMemberSearch",
          component: views.manager_IndividualMemberSearchPage,
        },
      ],
    },

    {
      // ERROR PAGE
      path: "/error",
      component: views.error_Error,
      children: [
        {
          path: "403",
          component: views.error_Error403,
        },
        {
          path: "404",
          component: views.error_Error404,
        },
      ],
    },

    {
      // REDIRECT NOT FOUND PAGE
      path: "*",
      redirect: "/error/404",
    },
  ],
});

// 페이지 이동 전 제어
router.beforeEach((to, from, next) => {
  // 인증이 필요한 페이지로 이동 시 현재 인증 상태를 확인한다.
  // 인증 상태가 아니라면 로그인 페이지로 이동
  const isAuth = store.state.auth.isAuth;
  const user = store.state.auth.user;
  const accessToken = localStorage.getItem(
    jwtUtil.LOCAL_STORAGE_KEY_ACCESS_TOKEN
  );

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (
      !isAuth ||
      user == null ||
      typeof user === "undefined" ||
      accessToken == null ||
      typeof accessToken === "undefined" ||
      accessToken === ""
    ) {
      next({
        path: "/auth",
        query: { redirect: to.path },
      });
      return;
    }
  }

  // 접근 권한이 맞지 않은 페이지에 접근하는 경우 403 페이지로 이동시킨다.
  var roles = null;
  if (
    to.matched.some((record) => {
      const recordRoles = record.meta.roles;
      if (recordRoles != null) roles = recordRoles;
      return recordRoles;
    })
  ) {
    if (roles && !roles.includes(store.state.auth.user.roleName)) {
      next({
        path: "/error/403",
        replace: true,
      });
      return;
    }

    // 개인, 기업회원인 경우 프로필 정보 필수값 검사 여부 확인
    // if (
    //   to.path != "/user" &&
    //   to.path != "/corp" &&
    //   store.state.auth.isChecked == false
    // ) {
    //   // 프로필 경로로 이동시킨다.
    //   var path = "/";

    //   switch (store.state.auth.user.roleName) {
    //     case ROLE.USER:
    //       path = "/user";
    //       break;
    //     case ROLE.CORP:
    //       path = "/corp";
    //       break;
    //     default:
    //       return;
    //   }

    //   next({
    //     path: path,
    //     replace: true,
    //   });
    // }
  }

  next();
});

export default router;
